import { IPortfolio } from "models/Portfolio/portfolioModel";
import { BaseService } from "./base.service";

class PortfolioServiceInternal extends BaseService {
	getPortfolioList = async (): Promise<IPortfolio[]> =>
		this.callApi<IPortfolio[]>(`Portfolio/GetPortfolioList`, "GET");
}

export const PortfolioService = new PortfolioServiceInternal();
